import extractNationalNumberFromPossiblyIncompleteNumber from "./extractNationalNumberFromPossiblyIncompleteNumber.js";
import matchesEntirely from "./matchesEntirely.js";
import checkNumberLength from "./checkNumberLength.js";
function extractNationalNumber(number, metadata) {
  var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(number, metadata), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
  if (nationalNumber !== number) {
    if (!shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata))
      return {
        nationalNumber: number
      };
    if (metadata.possibleLengths() && !isPossibleIncompleteNationalNumber(nationalNumber, metadata))
      return {
        nationalNumber: number
      };
  }
  return {
    nationalNumber,
    carrierCode
  };
}
function shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
  return !(matchesEntirely(nationalNumberBefore, metadata.nationalNumberPattern()) && !matchesEntirely(nationalNumberAfter, metadata.nationalNumberPattern()));
}
function isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
  switch (checkNumberLength(nationalNumber, metadata)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
export {
  extractNationalNumber as default
};
//# sourceMappingURL=extractNationalNumber.js.map
